import { name } from './name';
import { namespace } from './namespace';
import { created } from './created';

export const columns = [name, namespace, created];
